import { render, staticRenderFns } from "./pendingOrder.vue?vue&type=template&id=3e72ac9c&scoped=true&"
import script from "./pendingOrder.vue?vue&type=script&lang=js&"
export * from "./pendingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72ac9c",
  null
  
)

export default component.exports